import { Component, inject, input, model } from '@angular/core'
import { Router } from '@angular/router'


// These map to directives, e.g. icon-btn-icon-only etc
export enum IconButtonThemeType {
  Unstyled = 'unstyled',
  IconOnly = 'iconOnly',
  Outlined = 'outlined',
}
export enum IconButtonThemeSize {
  Small = 'small',
  Medium = 'medium',
  ResponsiveMedium = 'responsive-medium',
}
export enum IconButtonIconSize {
  XSmall = 'xsmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ResponsiveSmall = 'responsive-small',
  ResponsiveMedium = 'responsive-medium',
  ResponsiveLarge = 'responsive-large',
}

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  standalone: false,
})
export class IconButtonComponent {
  private _router = inject(Router)
  IconButtonThemeType = IconButtonThemeType
  IconButtonThemeSize = IconButtonThemeSize
  IconButtonIconSize = IconButtonIconSize
  matIcon = input('')
  themeType = model(IconButtonThemeType.IconOnly)
  themeSize = model(IconButtonThemeSize.Medium)
  iconSize = model(IconButtonIconSize.Medium)
  styleOverrides = input({})
  href = input<string>()
  routerLink = input<string | string[]>()
  disabled = input(false)
  ariaLabel = input<string>()
  themeDisabled = input(false)

  onClick() {
    const href = this.href()
    if (this.routerLink()) {
      this._router.navigate([this.routerLink()])
    } else if (href) {
      window.location.href = href
    }
  }
}
